export const AUTH0_ROLE_CLAIMS_KEY = 'https://cocodelivery.com/schemas/identity/claims/roles';
